import React from "react";

import "./style.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { changeXuan } from "../../store/pageSlice";
import { useEffect } from "react";

const Introduce = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  useEffect(()=>{
    const div = document.documentElement.querySelector('.div');
    div.style.height=0
    setTimeout(() => {
      div.style.height='auto'
    }, 2)
    dispatch(changeXuan(1))
  })
  const zhItem = () => {
    return (
      <>
      

      
        <img src="/img/2026-9/xin.png" style={{width:'100%'}}/>
        
      </>
    )
  }

  const enItem = () => {
    return (
      <>
      
        
        <img src="/img/2026-9/xin-en-9-16.png" style={{width:'100%'}}/>
      </>
    )
  }
  return (
    <div className="introduce">
      <div className="div">

        {/* <button onClick={() => { localStorage.removeItem('li_token')
        localStorage.removeItem('li_user_id') }} style={{ position: 'absolute' }}>登出</button> */}
        <img
            className="mask-group"
            alt="Mask group"
            src="/img/2026-9/bg2.png"
        />
        <img src={t("is_en") == 1 ? "/img/logo-en.png" : "/img/login/logo.png"} alt="" className="logo"/>
        {/*<img src={t("is_en") == 1 ? "/img/logo-en.png" : "/img/login/logo.png"} alt="" className="logo"/>*/}

        {
          t("is_en") === '1' ? enItem() : zhItem()
        }

      </div>
    </div>
  );
};

export default Introduce
